import UrcenieGestora from './UrcenieGestora';

export default UrcenieGestora;
